import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import React from 'react';

const SelectComponent = ({ value, onChange, items }) => (
  <Select value={value} onChange={onChange}>
    {items.map(item => (
      <MenuItem key={item.value} value={item.value}>
        {item.label}
      </MenuItem>
    ))}
  </Select>
);

export default SelectComponent;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/Select/Select.js